import DispatcherAddRequest, {
  DispatcherAddRequestBody,
} from "./add/dispatcher-add.request";
import HttpResponse from "../../../utils/http/http.response";
import railyApiService from "../raily-api.service";
import dispatcherAddRequestFactory from "./add/dispatcher-add-request.factory";

const dispatcherApiService = () => {
  const add = (
    request: DispatcherAddRequest,
    abortSignal: AbortSignal,
  ): Promise<HttpResponse> => {
    const url = `/dispatchers`;

    const body: DispatcherAddRequestBody =
      dispatcherAddRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  return { add };
};

export default dispatcherApiService;
